export default __webpack_public_path__ + "static/media/LOGO_TITULO_ORG_18.a45a0e8e.png";